import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

function ManageBankInfo({ selected, updateDefaultAccount, item, oldDefaultAccount, hideNickName }) {
  const [nick_name, setNickName] = useState("");

  const [show, setShow] = useState(false);
  const [check, setCheck] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 570);

  const handleClose = () => {
    if (item?.default_bank_account === 0) setCheck(false);
    setShow(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 570);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (item?.default_bank_account === 1) setCheck(true);
  }, [selected]);

  const handleOnChange = () => {
    setCheck(!check);
  };
  useEffect(() => {
    setNickName(item?.nick_name);
  }, [item?.nick_name]);

  const handleSave = async () => {
    if (oldDefaultAccount) {
      await updateDefaultAccount({
        ...oldDefaultAccount,
        default_bank_account: 0,
      });
    }
    await updateDefaultAccount({
      ...item,
      nick_name,
      default_bank_account: check ? 1 : 0,
    });
    handleClose();
  };

  return (
    <>
      <li className="dropdown-item" onClick={() => setShow(true)}>
        <img src={require("../../../assets/images/edit.svg").default} />
        <span>Edit</span>
      </li>
      <Modal
        className={`w-100 ${isMobile ? "modal-style-bottom" : "modal-style-1"}`}
        centered
        show={show}
        onHide={handleClose}
      >
        <div className="modal-header">
          <h4 className="modal-title">Edit Bank Account</h4>
        </div>
        <Modal.Body>
          {!hideNickName && (
            <div className="my-3">
              <label className="mb-2">Account Name / Nickname</label>
              <input
                value={nick_name}
                onChange={(e) => setNickName(e.target.value)}
                type="text"
                className="form-control"
              />
            </div>
          )}
          <div className="form-switch d-flex d-md-flex justify-content-between justify-content-md-start mt-4">
            <div className="d-flex align-items-center mb-4">Make Default</div>
            <form>
              <input
                type="checkbox"
                hidden="hidden"
                id="editSetupDefault"
                checked={check}
                onChange={handleOnChange}
                defaultChecked={selected === "Default"}
              />
              <label className="switch" htmlFor="editSetupDefault" />
            </form>
          </div>
          <Row>
            <Col xs={12} xl={6}>
              <Button className="w-100 me-3" variant="warning-inverse" onClick={handleClose}>
                Cancel
              </Button>
            </Col>
            <Col xs={12} xl={6}>
              <Button className="w-100 mt-4 mt-md-0" variant="primary" onClick={handleSave}>
                Save
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ManageBankInfo;
